import { render, staticRenderFns } from "./Family-statement-conflict-search.vue?vue&type=template&id=94b5ee3c&scoped=true"
import script from "./Family-statement-conflict-search.vue?vue&type=script&lang=js"
export * from "./Family-statement-conflict-search.vue?vue&type=script&lang=js"
import style0 from "./Family-statement-conflict-search.vue?vue&type=style&index=0&id=94b5ee3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b5ee3c",
  null
  
)

export default component.exports